
import { AuthService, BookYearService } from "@/services";
import { UserConfigService } from "@/services/user-config-service";
import { ToolbarService } from "@/services/toolbar-service";
import { DrawerLink } from "@/utils/drawer-links/drawer-link";
import { findFixedDrawerLinkByUid } from "@/utils/drawer-links/fixed-drawer-links";
import Vue from "vue";
import { processIframeUrl } from "@/utils/iframe";

export default Vue.extend({
	data() {
		return {
			link: null as DrawerLink | null,
			childOrigin: ""
		};
	},
	computed: {
		computedUrl(): string {
			if (!this.link) return "";
			return processIframeUrl(this.link.Url, {useElectronServerAsProxy: this.link.UseDesktopAppAsProxy});
		}
	},
	watch: {
		"$route.params.uid": {
			immediate: true,
			handler() {
				this.loadLink();
			}
		}
	},
	methods: {
		loadLink() {
			const uid = this.$route.params.uid;
			const wrapper = UserConfigService.getDrawerLinkSettings();
			const found = wrapper.findByUid(uid) || findFixedDrawerLinkByUid(uid);
			this.link = found || null;
			if (this.link) {
				ToolbarService.title = this.link.Title;
			}
		},
		sendAppData(frame: HTMLIFrameElement) {
			if (!this.childOrigin) return;
			let app = {
				bookyear: BookYearService.selectedBookYear,
				dossier: AuthService.wfDossier.id,
				userId: AuthService.wfUser.ID,
				accessToken: AuthService.tokenStore.getSelectedToken().token,
				socketId: AuthService.tokenStore.socketId
			};
			frame.contentWindow?.postMessage({app}, this.childOrigin);
		},
		async onMessage(e: MessageEvent) {
			if (e.data?.type === "IFRAME_READY") {
				this.childOrigin = e.origin;
				let frame = this.$refs.frame as HTMLIFrameElement;
				if (frame) {
					setTimeout(() => {
						this.sendAppData(frame);
					}, 150);
				}
			}
			if (e.data?.type === "REQUEST_TOKEN") {
				await AuthService.refreshTokens();
				let frame = this.$refs.frame as HTMLIFrameElement;
				if (frame) {
					this.sendAppData(frame);
				}
			}
		}
	},
	mounted() {
		window.addEventListener("message", this.onMessage);
	},
	beforeDestroy() {
		window.removeEventListener("message", this.onMessage);
	}
});
